/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import AgeGate from './age-gate';

export * from './age-gate.props';

/**
 * Exporting the AgeGate components.
 */
export { AgeGate };
